module.exports = __webpack_public_path__ + "media/images/cats/cat-pregnancy-calculator-week-6-and-7.jpg";